const getUpgradeBrazilPlansDictionary = function (data) {
  const brazilUpgradePlansDictionary = {
    trademo_intel_br_pro: {
      name: "Trademo intel brazil Pro",
      key: "trademo_intel_br_pro",
      upgradeMessageArrivalDate: "You have access last 12 months of trade data. To access complete data.",
      upgradeMessageEmailAlert: "You do not have sufficient credits available to set Email Alert. To set more alerts ",
      upgradeMessageXlsDownload: "You do not have sufficient credits available to download XXX shipments.",
      upgradeMessageLiveNotification: "You have access last 12 months of trade data. To access complete data. ",
      dashboardUpgradeMessageEmailAlert: "",
      planFeatures: [
        "Last 12 months shipments data",
        "Unlimited searches per day",
        "120,000 shipment downloads per user annually",
        "1,000 employee level contact",
        "downloads per user annually",
        "Advanced Filters",
        "Monthly data update",
        "Single User License",
      ],
    },
    trademo_intel_br_advanced: {
      name: "Trademo intel brazil Advanced",
      key: "trademo_intel_br_advanced",
      upgradeMessageArrivalDate: "You have access last 24 months of trade data. To access complete data.",
      upgradeMessageEmailAlert: "You do not have sufficient credits available to set Email Alert. To set more alerts ",
      upgradeMessageXlsDownload: "You do not have sufficient credits available to download XXX shipments.",
      upgradeMessageLiveNotification: "You have access last 24 months of trade data. To access complete data.",
      dashboardUpgradeMessageEmailAlert: "Never miss out on tracking important shipments.",
      planFeatures: [
        "Last 24 months shipments data",
        "Unlimited Searches per day",
        "300,000 shipment downloads per user annually",
        "1,000 employee level contact",
        "downloads per user annually",
        "Advanced Filters",
        "Monthly data update",
        "Single User License",
        "Analytics & Insights on Search",
        "Unlimited email alerts",
      ],
    },
    trademo_intel_br_enterprise: {
      name: "Trademo intel brazil enterprise",
      key: "trademo_intel_br_enterprise",
      upgradeMessageArrivalDate: "You have access to only historical data. To access recent  Shipments. ", // Need to change the content (Not In Use Right Now)
      upgradeMessageEmailAlert: "You do not have sufficient credits available to set Email Alert. To set more alerts ", // Need to change the content (Not In Use Right Now)
      upgradeMessageXlsDownload: "You do not have sufficient credits available to download XXX shipments.",
      upgradeMessageLiveNotification: "You have access to only historical data. To access recent  Shipments. ", // Need to change the content (Not In Use Right Now)
      dashboardUpgradeMessageEmailAlert: "",
      planFeatures: [
        "Jan 2021 - Present shipments data",
        "Unlimited Searches per day",
        "Unlimited shipments downloads annually with 45K downloads at a time per user",
        "1,000 employee level contact downloads per user annually",
        "Advanced Filters",
        "Monthly data update",
        "Total 3 user licences",
        "Analytics & Insights on Search",
        "Unlimited email alerts",
      ],
    },
  };
  return brazilUpgradePlansDictionary;
};
exports.getUpgradeBrazilPlansDictionary = getUpgradeBrazilPlansDictionary;
